export const tabList = [
  'PRODUCT_INFO',
  'BOOKING_INFO',
  'COMMISSION_INFO',
  'STUDENT_INFO',
  'RECONCILIATION_HISTORY',
];
